/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_deposit_modal_instruction_3 = /** @type {(inputs: {}) => string} */ () => {
	return `Verifica siempre el ID antes de realizar un depósito`
};

const en_cards_deposit_modal_instruction_3 = /** @type {(inputs: {}) => string} */ () => {
	return `Always verify the ID before making a deposit`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_deposit_modal_instruction_3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_deposit_modal_instruction_3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_deposit_modal_instruction_3", locale)
	if (locale === "es") return es_cards_deposit_modal_instruction_3(inputs)
	return en_cards_deposit_modal_instruction_3(inputs)
};
export { cards_deposit_modal_instruction_3 as "cards.deposit_modal.instruction_3" }